export const art70 = [
    // {
    //     "nombre": "Hipervinculo a los Planes de Desarrollo Urbano",
    //     "url": "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art70/a70_f01_f1.xlsx",
    // },
    {
        "nombre": "Planes y Programas de desarrollo Urbano",
        "url": "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art70/1f-LGT_Art_71_Fr_If Planes yo programas de desarrollo urbano.xlsx",
    },
    {
        "nombre": "Planes y Programas de Ordenamiento Territorial",
        "url": "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art70/2f-LGT_Art_71_Fr_If Planes y Programas de ordenamiento territorial.xlsx",
    },
    {
        "nombre": "Tipos de Uso del Suelo",
        "url": "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art70/4f-LGT_Art_71_Fr_If Tipos de uso de suelo.xlsx",
    },
    {
        "nombre": "Licencias de Uso del Suelo",
        "url": "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art70/5f-LGT_Art_71_Fr_If Licencias de uso de suelo.xlsx",
    },
    {
        "nombre": "Licencias de Construcción",
        "url": "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art70/6f-LGT_Art_71_Fr_If Licencias de construcción.xlsx",
    },
    {
        "nombre": "Disposiciones administrativas",
        "url": "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art70/a70_f01_g Disposiciones administrativas.xlsx",
    }
]